export enum TakipMahiyeti {
    belgesiz = 1,
    cocukTeslimi = 2,
    diger = 3,
    dogalGaz = 4,
    elektrik = 5,
    internetTv = 7,
    krediKarti = 8,
    krediSozlesmesi = 9,
    nafaka = 10,
    su = 11,
    telefonCep = 12,
    telefonSabit = 13,
    tuketiciHakemHeyeti = 14,
    paraAlacagi = 15,
    arabuluculuk = 16,
    ilamliCocukTeslimi = 17,
    ilamliNafaka = 18,
    ilamliTuketiciHakemHeyeti = 19,
    birIsinYapilmasi = 20,

}

export enum TakipMahiyetiLabel {
    belgesiz = "Belgesiz",
    cocukTeslimi = "Çocuk Teslimi",
    diger = "Diğer",
    dogalGaz = "Doğal Gaz",
    elektrik = "Elektrik",
    internetTv = "İnternet/TV",
    krediKarti = "Kredi Kartı",
    krediSozlesmesi = "Kredi Sözleşmesi",
    nafaka = "Nafaka",
    su = "Su",
    telefonCep = "Telefon (Cep)",
    telefonSabit = "Telefon (Sabit)",
    tuketiciHakemHeyeti = "Tüketici Hakem Heyeti",
    paraAlacagi = "Para Alacağı",
    arabuluculuk = "Arabuluculuk",
    birIsinYapilmasi = "Bir İşin Yapılması",

}

